import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getTimeUntilMidnight } from '../utils/rateLimitUtils';
import './RateLimitModal.css';

export const RateLimitModal = ({ onClose }) => {
  const [timeRemaining, setTimeRemaining] = useState(getTimeUntilMidnight());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(getTimeUntilMidnight());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      className="rate-limit-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="rate-limit-modal"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="rate-limit-content">
          <h2 className="rate-limit-title">Cosmic Limit Reached 🌙</h2>
          
          <p className="rate-limit-message">
            The stars need a break, bestie.
            <br />
            You've had 3 readings today —
            <br />
            the universe has said enough. 😭
            <br />
            <br />
            Come back tomorrow for more
            <br />
            cosmic destruction.
          </p>

          <div className="countdown-section">
            <p className="countdown-label">Next reading available in:</p>
            <div className="countdown-timer">
              {timeRemaining.formatted} ⏰
            </div>
          </div>

          <p className="rate-limit-reason">
            Why limit? Too many people getting
            <br />
            roasted at once breaks our
            <br />
            cosmic servers 😂
          </p>

          <button className="close-modal-btn" onClick={onClose}>
            Got it, bestie ✨
          </button>
        </div>

        {/* Decorative stars */}
        <div className="modal-stars">
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className="modal-star"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animation: `twinkle-modal ${2 + Math.random() * 2}s infinite`,
              }}
            />
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};
